module.exports = __webpack_public_path__ + "img/nu.1db5a99d.svg";